import { NavLink, useLocation } from 'react-router-dom';
import { cn } from '../../lib/utils';
import { useAuth } from '../../contexts/AuthContext';
import {
  LayoutDashboard,
  Cloud,
  Bell,
  Settings,
  Users,
  LogOut,
  Layers,
  TableProperties
} from 'lucide-react';

const navItems = [
  { path: '/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { path: '/costs', label: 'Coûts', icon: TableProperties },
  { path: '/services', label: 'Services', icon: Layers },
  { path: '/alerts', label: 'Alertes', icon: Bell },
];

const adminItems = [
  { path: '/providers', label: 'Providers', icon: Cloud },
  { path: '/settings', label: 'Paramètres', icon: Settings },
  { path: '/admin/users', label: 'Utilisateurs', icon: Users },
];

export const BottomNav = () => {
  const { isAdmin, logout } = useAuth();
  const location = useLocation();

  const allItems = isAdmin ? [...navItems, ...adminItems] : navItems;

  return (
    <nav
      data-testid="bottom-nav"
      className="md:hidden fixed bottom-0 left-0 right-0 bg-card border-t border-border z-50"
    >
      <div className="flex items-center justify-around px-1 py-2 overflow-x-auto scrollbar-thin">
        {allItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;

          return (
            <NavLink
              key={item.path}
              to={item.path}
              data-testid={`mobile-nav-${item.path.replace('/', '').replace('/', '-')}`}
              className={cn(
                "flex flex-col items-center gap-0.5 px-2 py-1.5 rounded-lg transition-all duration-200",
                "hover:bg-accent min-w-[48px]",
                isActive && "bg-primary/10 text-primary"
              )}
            >
              <Icon className={cn("w-5 h-5", isActive && "text-primary")} />
              <span className={cn(
                "text-[9px] leading-tight",
                isActive ? "font-medium text-primary" : "text-muted-foreground"
              )}>
                {item.label}
              </span>
            </NavLink>
          );
        })}
        <button
          onClick={logout}
          data-testid="mobile-logout-btn"
          className="flex flex-col items-center gap-0.5 px-2 py-1.5 rounded-lg transition-all duration-200 hover:bg-destructive/10 min-w-[48px]"
        >
          <LogOut className="w-5 h-5 text-destructive" />
          <span className="text-[9px] leading-tight text-destructive">Sortir</span>
        </button>
      </div>
    </nav>
  );
};
